export default "__VITE_ASSET__bd45dbc1__"